<div class="" [ngClass]="{'card p-3': displayTitle}">
  <p *ngIf="displayTitle"><strong>Datos de localización</strong></p>
  <div [formGroup]="form">  
    <div class="form-container mb-3">
      <div class="form-group" >
        <custom-select
          [filterEnabled]="true"
          [labelText]="'Eje'"
          [bordered]="true"
          name="vialAxis"
          id="vialAxis"
          [isDisabled]="isDisabled"
          formControlName="vialAxes"
          [(sourceList)]="_vialAxesList"
          required>
        </custom-select>
      </div>
      <div class="form-group">
        <label for="kilometer">PK</label>
        <input
          type="tel"
          formControlName="kilometer"
          class="form-control"
          id="kilometer"
          name="kilometer"
          lang="en"
          pattern="^([.]?[0-9.]+)"
          [customMax]="99999999"
          (input)="searchReferencePoints()"
          (paste)="_formValidatorService.validateOnlyNumberAndDot($event)"
          (keypress)="($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode <= 57))"
          required/>
      </div>
      <div class="form-group" >
        <custom-select
          [filterEnabled]="true"
          [labelText]="'Vía'"
          [bordered]="true"
          name="roadway"
          id="roadway"
          [isDisabled]="isDisabled"
          formControlName="roadway"
          [(sourceList)]="_roadwayList"
          (select)="onSelectRoadway()"
          required>
        </custom-select>
      </div>
      
      <div class="form-group">
        <label for="trafficDirections">Calzada</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="trafficDirections"
          id="trafficDirections"
          [isDisabled]="isDisabled"
          formControlName="trafficDirections"
          [(sourceList)]="_trafficDirectionsList"
          required>
        </custom-select>
      </div>
      <div class="form-group" >
        <label for="sector">Comuna</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="sector"
          id="sector"
          [isDisabled]="isDisabled"
          formControlName="sector"
          [(sourceList)]="_sectorList"
          required
          (select)="onSectorChange(sector?.value?.value)">
        </custom-select>
      </div>
      <div class="form-group" >
        <label for="subSector">Sector</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="subSector"
          id="subSector"
          [isDisabled]="isDisabled"
          formControlName="subSector"
          [(sourceList)]="_subSectorList"
          required>
        </custom-select>
      </div>
    </div>
  </div>
  
</div>
 